import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import * as React from 'react';
import { Box, GDSStyleObject } from '@leagueplatform/genesis-core';
import { LEAGUE_MODULE_NAMES, getModulePath } from '@leagueplatform/core';
import { useMatch } from '@leagueplatform/routing';
import { AppNavBarComponent } from 'components/header-nav/navbar/nav.component';
import { SDK_CSS_OVERRIDES } from 'common/ui';
import { GlobalFooter } from './global-footer/global-footer.component';

type BasePageProps = React.PropsWithChildren<{
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
}>;

export const BasePage: React.FC<BasePageProps> = ({
  children,
  isPrivatePage = true,
  css,
}) => {
  useScrollTopOnLocationChange();

  const isActivity = useMatch({
    path: `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/activity`,
  });

  const isToolboxActivity = useMatch({
    path: `${getModulePath(
      LEAGUE_MODULE_NAMES.healthJourney,
    )}/activity/:userActivityId/toolbox`,
  });

  const isCampaignToolboxActivity = useMatch({
    path: `${getModulePath(
      LEAGUE_MODULE_NAMES.healthJourney,
    )}/campaign/:campaignId/activity/:userActivityId/toolbox`,
  });

  const hideFooter =
    isActivity || isToolboxActivity || isCampaignToolboxActivity;

  const isToolbox = isToolboxActivity || isCampaignToolboxActivity;

  return (
    <Box
      css={{
        [isToolbox ? 'minHeight' : 'height']: '100vh',
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRows: isPrivatePage ? 'auto 1fr auto' : '1fr',
        overflowInline: 'hidden',
      }}
    >
      {isPrivatePage && <AppNavBarComponent />}
      <Box
        as="main"
        css={{
          position: 'relative',
          paddingBlockEnd: !isToolbox ? '$three' : undefined,
          ...SDK_CSS_OVERRIDES,
          ...css,
        }}
      >
        {children}
      </Box>
      {isPrivatePage && !hideFooter && <GlobalFooter />}
    </Box>
  );
};
